import React from "react";

const Team = () => {
  const teamMembers = [
    {
      img: "img/team-1.jpg",
      name: "Dra. Ana María Hassan",
      specialty: "Endodoncia / prótesis",
      social: {}
    },

    {
      img: "img/team-3.jpg",
      name: "Dra. Carolina Suárez Fernández",
      specialty: "Ortodoncia",
      social: {
        instagram: "https://www.instagram.com/dracarolinasuarezfernandez/"
      }
    },

  ];
  
  return (
    <div className="container-fluid py-5">
      <div className="container">
        <div className="row g-5 justify-content-center">
          {/* Título y botón */}
          <div className="col-12 col-lg-4 wow slideInUp" data-wow-delay="0.1s">
            <div className="section-title bg-light rounded h-100 p-5">
              <h5 className="position-relative d-inline-block text-primary text-uppercase">
                Nosotras
              </h5>
              <h1 className="display-6 mb-4">Conocé a las odontólogas de Lash</h1>
              <a href="/appointment" className="btn btn-primary py-3 px-5">
                Agendar
              </a>
            </div>
          </div>
          {teamMembers.map((member, index) => (
            <div
              className="col-12 col-md-6 col-lg-4 wow slideInUp"
              data-wow-delay={`${0.1 + index * 0.2}s`}
              key={index}
            >
              <div className="team-item">
                <div className="position-relative rounded-top" style={{ zIndex: 1 }}>
                  <img
                    className="img-fluid rounded-top w-100"
                    src={member.img}
                    alt={`Foto de ${member.name}`}
                  />
                  {member.name === "Dra. Carolina Suárez Fernández" && (
                    <div className="position-absolute top-100 start-50 translate-middle bg-light rounded p-2 d-flex">
                      <a className="btn btn-primary btn-square m-1" href={member.social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                        <i className="fab fa-instagram fw-normal"></i>
                      </a>
                    </div>
                  )}
                </div>
                <div className="team-text position-relative bg-light text-center rounded-bottom p-4 pt-5">
                  <h4 className="mb-2">{member.name}</h4>
                  <p className="text-primary mb-0">{member.specialty}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Team;